import React from 'react';
import { Accent, SectionHeading } from './SectionHeading';
import { guides } from '../../data/content';
export function VolumesSection() {
  return <section aria-labelledby="system-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-201" data-mp="hyulz8ehh821">
      <div className="mx-auto max-w-6xl" data-id="element-202" data-mp="3zv18bu3ddb5">
        <SectionHeading id="system-heading" eyebrow="The Complete Teaching Library" title={<>
              6 Volumes. <Accent data-id="element-204" data-mp="vr1593cxnv5p">150 Ready-to-Teach</Accent> Nail Lessons.
            </>} body="From professional foundations to advanced troubleshooting and student assessment, the system gives you a structured teaching library covering the core areas of modern nail education." data-id="element-203" data-mp="7yu1vk8sinws" />

        <ol className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-205" data-mp="qweoslrzvcer">
          {guides.map(guide => <li key={guide.number} className="flex h-full flex-col rounded-[18px] px-6 py-7" style={{
          backgroundColor: guide.accent
        }} data-id="element-206" data-mp="1elpn7wlvgupq">
              <p className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-charcoal/60" data-id="element-207" data-mp="cj6oz3c1jp2g">
                Volume {guide.number}
              </p>
              <span aria-hidden="true" className="mt-3 block h-px w-8 bg-brand-gold" data-id="element-208" data-mp="mbujfrfjtgy0" />
              <h3 className="mt-4 font-display text-[1.45rem] font-bold leading-snug text-brand-charcoal" data-id="element-209" data-mp="hjb70xslkrus">
                {guide.title}
              </h3>
              <p className="mt-2 text-[14px] leading-relaxed text-brand-charcoal/70" data-id="element-210" data-mp="vdlmspmm9bop">{guide.description}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}